import WithRender from "../../templates/containers/pageOptionSummaryContainer.html";
import { mapGetters } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters([
      "getAddToCartFullPage",
      "getSummaryPageOptionActive",
      "getMatrixComplete",
      "getPersonalizationFullPage",
      "getHideUploadContainer",
      "getHideLinks",
      "getUrl"
    ]),
    designLogoHeader() {
      return i18n.t("Design your logo");
    },
    designLogoContent() {
      if (this.getHideUploadContainer) {
        return i18n.t("Design your content");
      }
      return i18n.t("Upload or design your logo");
    },
    helpHeader: () => {
      return i18n.t("Help");
    },
    helpContent() {
      var text = i18n.t("Help content");
      //var text = i18n.t("Help content :contactlink test :faqlink faq");
      text = text
        .replace(
          ":contactlink",
          "<a href='" +
            this.getUrl("contactFormUrl") +
            "'>" +
            i18n.t("HelpContactLinkName") +
            "</a>"
        )
        .replace(
          ":faqlink",
          "<a href='" +
            this.getUrl("faqFormUrl") +
            "'>" +
            i18n.t("HelpFaqLinkName") +
            "</a>"
        );
      return text;
    },
    getInstructionsUrl() {
      return this.getUrl("instructionsUrl");
    },
    printingInfo() {
      return i18n.t("Printing instructions");
    }
  },
  props: ["hideContainer"]
});
